import React from 'react'

import CustomFieldIcon from "../form-icon"
import CustomFieldType from "../form-type"
import CustomFieldId from "../form-id"

type Props = {
    parent      : {
        type        : number
        props       : any
    }

    children?   : any
}

export default function CustomFieldLeftPanel(props: Props) {

    return (
        <div className="iv-left-column iv-column">
            <CustomFieldIcon type={props.parent.type}/>
            <CustomFieldType type={props.parent.type}/>
            <CustomFieldId customField={props.parent.props.customField}/>

            {props.children}
        </div>
    )
}